import { render, staticRenderFns } from "./airlines.vue?vue&type=template&id=6b7daa2c&scoped=true&"
var script = {}
import style0 from "./airlines.vue?vue&type=style&index=0&id=6b7daa2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7daa2c",
  null
  
)

export default component.exports